(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.buyers-count').forEach(function(el) {
    el.textContent = Math.floor(Math.random() * 17) + 18;
    setInterval(function() {
      el.textContent = parseInt(el.textContent) + 1;
    }, Math.floor(Math.random() * 180000) + 120000);
  });
  } catch(e) { console.error(e); }
})();

})();
